import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const language = localStorage.getItem('language') || 'ar';
    const requestHeader = {
      'accept-language': language,
      lang: language
    } as any;

    request = request.clone({
      setHeaders: requestHeader
    });
    return next.handle(request);
  }
}
